module.exports = __webpack_public_path__ + "static/media/css.9c9c21e8.svg";